import { datadogRum } from "@datadog/browser-rum";
import Router from "next/router";
import { getUsedCarsUrlFilterHistoryFromSessionStorage, mapFiltersToUrl, setUsedCarsUrlFilterHistoryInSessionStorage } from "../../utils";
const updateUsedCarsFilterHistoryWithPathAndFilter = (path, state)=>{
    const usedCarsFilterHistory = getUsedCarsUrlFilterHistoryFromSessionStorage();
    if (!usedCarsFilterHistory) {
        setUsedCarsUrlFilterHistoryInSessionStorage({
            [path]: state
        });
        return;
    }
    setUsedCarsUrlFilterHistoryInSessionStorage({
        ...usedCarsFilterHistory,
        [path]: state
    });
};
export const urlMiddleware = (stateCreator, name)=>(set, get, store)=>{
        const updateUrlSet = (...newState)=>{
            set(...newState);
            // with the params we have make a url and change page url
            const state = get();
            const filtersToMap = {
                bodyType: state.bodyType,
                colour: state.colour,
                seats: state.seats,
                doors: state.doors,
                fromEngineSize: state.fromEngineSize,
                toEngineSize: state.toEngineSize,
                fuelType: state.fuelType,
                make: state.make,
                model: state.model,
                trim: state.trim,
                mileage: state.mileage,
                fromPrice: state.fromPrice,
                toPrice: state.toPrice,
                gearbox: state.gearbox,
                fromYear: state.fromYear,
                toYear: state.toYear,
                driveType: state.driveType,
                store: state.store,
                tags: state.tags,
                features: state.features,
                sortingCriteria: state.sortingCriteria,
                pageNumber: state.pageNumber,
                pageSize: state.pageSize,
                useMonthly: state.useMonthly
            };
            const path = mapFiltersToUrl(filtersToMap, state.allCinchStoresLowercase);
            updateUsedCarsFilterHistoryWithPathAndFilter(path, filtersToMap);
            Router.push(`/${path}`, undefined, {
                shallow: true
            });
            // not related to the URL, so if we add similar things here in the future, may want moving into a separate middleware
            datadogRum.setGlobalContextProperty("search-filters", filtersToMap);
        };
        store.setState = updateUrlSet;
        return stateCreator(updateUrlSet, get, store);
    };
